export const maestroElectricBonuses = [
  {
    number: '01',
    perceivedValue: '$14.990',
    title: 'DIAGNÓSTICO RÁPIDO DE FALLAS ELÉCTRICAS',
    description: 'Identificá síntomas, posibles causas y qué revisar primero.',
    image: 'https://cdn.magicpatterns.com/uploads/dQTukWtor83ieMqWKD7UmA/Creating_digital_book_cover_20261024180641.webp'
  },
  {
    number: '02',
    perceivedValue: '$9.990',
    title: 'CHECKLIST DE VERIFICACIÓN ELÉCTRICA',
    description: 'Repasá conexiones, protecciones y puntos clave antes de energizar.',
    image: 'https://cdn.magicpatterns.com/uploads/n7a2TasrNPx13csJuoiSZT/Creating_book_cover_design_20261024182337.webp'
  },
  {
    number: '03',
    perceivedValue: '$12.990',
    title: 'GUÍA DE MATERIALES POR INSTALACIÓN',
    description: 'Tené a mano los materiales habituales según el tipo de instalación.',
    image: 'https://cdn.magicpatterns.com/uploads/uBBwkpBqM8Z3TC1eL3UGCk/Create_Maestro_Electrico_book_cover_20261024184054.webp'
  },
  {
    number: '04',
    perceivedValue: '$14.990',
    title: 'PRESUPUESTADOR DE INSTALACIONES ELÉCTRICAS',
    description: 'Organizá costos, mano de obra, imprevistos y margen.',
    image: 'https://cdn.magicpatterns.com/uploads/aNfYzmASdUtf2vrnPqsnfe/Designing_electrical_budgeting_b…_20261024184819.webp'
  },
  {
    number: '05',
    perceivedValue: '$9.990',
    title: 'GUÍA DE RELEVAMIENTO ELÉCTRICO',
    description: 'Registrá datos de obra, ambientes, circuitos y equipos antes de presupuestar.',
    image: 'https://cdn.magicpatterns.com/uploads/qLTb4ieeLkGpaGxDo6DByd/Create_electrical_guide_book_cover_20261024184841.webp'
  }
] as const;
